import {FormSearch} from './FormSearch.mjs';
import config from '../config.mjs';
import Storage from './Storage.mjs';

export default class FormRestartSearch extends FormSearch {
  constructor(form) {
    super(form);
    // No map needed
    // This is also an indicator that this form not the main search
    this.Map = undefined;
  }

  /**
   * @param {string} name
   * @param {google.maps.LatLng} coordinates
   */
  getStoresNearby(name, coordinates) {
    // Save search
    Storage.setItem('lastSearch', {
      name,
      coordinates,
    });

    // Redirect
    document.location = config.startPageUrl;
  }
}
